// @core/api/endpoints/user/create_user_internal.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateUserInternalRequest,
  UserResponse,
} from '../../../types/user';

const BASE_PATH = '/user';

/**
 * Create user (internal)
 * Creates a new user without authorization checks. Service-to-service only (authn SignUp).
 */
export async function CreateUserInternal(
  data: CreateUserInternalRequest,
  options?: RequestOptions
): Promise<UserResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/internal/create`;
  const requestOptions = options;
  return client.post<UserResponse>(requestPath, data, requestOptions);
}
